import React, { forwardRef } from 'react';

import { StyledIcon } from '../StyledIcon';

const PowerReset = forwardRef((props, ref) => (
  <StyledIcon ref={ref} viewBox="0 0 24 24" a11yTitle="PowerReset" {...props}>
    <path d="M21 0.5C21.5523 0.5 22 0.947715 22 1.5V7.37012C21.9999 7.9941 21.4941 8.49994 20.8701 8.5H15C14.4477 8.5 14 8.05228 14 7.5C14 6.94772 14.4477 6.5 15 6.5H19.124C17.477 4.36986 14.8981 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 11.4477 21.4477 11 22 11C22.5523 11 23 11.4477 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1C15.1531 1 17.995 2.32747 20 4.45117V1.5C20 0.947715 20.4477 0.5 21 0.5Z" fill="#000" /><path d="M12 8C12.5523 8 13 8.44772 13 9V15C13 15.5523 12.5523 16 12 16C11.4477 16 11 15.5523 11 15V9C11 8.44772 11.4477 8 12 8Z" fill="#000" />
  </StyledIcon>
));

PowerReset.displayName = 'PowerReset';

export { PowerReset };
